import DatePicker from 'antd-mobile/lib/date-picker';
export default DatePicker;



// WEBPACK FOOTER //
// ./components/date-picker/index.tsx